import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import {TransitionMotion, spring, presets} from 'react-motion';


class Header extends React.Component {

    static propTypes = {
        className: React.PropTypes.string,
        children: React.PropTypes.node
    };

    getStartValue() {
        return {
            header: {
                marginLeft: spring(-20, [200,30]),
                opacity: spring(0, [200,30])
            }
        };
    }

    getEndValue() {
        return {
            header: {
                marginLeft: spring(0, [200,30]),
                opacity: spring(1, [200,30])
            }
        };
    }

    render() {
        let classes = {
            'page-header': true
        };

        let {className, children, ...props} = this.props;

        return (
            <header className={classNames(classes, className)} {...props}>
                <TransitionMotion defaultStyles={this.getStartValue()}
                                  styles={this.getEndValue()}
                >
                    {configs =>
                        <div className="page-header__titles" style={configs.header}>
                            {children}
                        </div>
                    }
                </TransitionMotion>

            </header>
        );
    }
}

export default Header;